import { twSort } from 'atp-react-ui';

export const STYLE = {
  bubbleChat: twSort`mb-6 mt-6 w-full rounded-xl rounded-bl-none bg-white p-4 font-serif text-2xl font-medium text-secondary-dark shadow-card-primary-x-light lg:px-7 lg:py-5 lg:text-3.5xl lg:font-normal`,
  header: twSort`mb-6 mt-4 font-serif text-2xl font-normal leading-8 tracking-wide text-secondary-dark md:text-2xl md:leading-10 lg:mt-0 lg:text-3xl lg:leading-10 lg:tracking-wide xl:text-3.5xl xl:leading-12`,
  subHeader: twSort`font-sans text-lg font-normal tracking-x-wide text-secondary-dark lg:text-xl lg:leading-10 lg:tracking-wider`,
};
